import template from './videoItem.html';
import controller from './videoItem.controller';
import './videoItem.scss';

let videoItemComponent = {
  restrict: 'E',
  bindings: {video: '<'},
  template,
  controller
};

export default videoItemComponent;



// WEBPACK FOOTER //
// ./client/app/components/apps/videoItem/videoItem.component.js